import { MODULES } from './constants/moduleConstants'

export default {
  items: [
    {
      name: 'Home',
      url: '/home',
      icon: 'icon-home',
      attributes: {
        'data-testid': 'nav-home'
      }
    },
    {
      name: 'Getting Started',
      url: '/gettingstarted',
      icon: 'icon-control-play',
      attributes: {
        'data-testid': 'nav-getting-started'
      }
    },
    {
      name: 'Users',
      icon: 'icon-user-follow',
      attributes: {
        'data-testid': 'nav-users'
      },
      children: [
        {
          name: 'Active Users',
          url: '/users/activeusers',
          attributes: {
            'data-testid': 'nav-active-users'
          }
        },
        {
          name: 'Blocked Users',
          url: '/users/blockedlist',
          attributes: {
            'data-testid': 'nav-blocked-users'
          }
        },
        {
          name: 'User Attributes',
          url: '/users/userattributes',
          attributes: {
            'data-testid': 'nav-user-attributes'
          }
        },
        {
          name: 'Relationships',
          url: '/focuspeople',
          attributes: {
            'data-testid': 'nav-relationships'
          }
        }
      ]
    },
    {
      name: 'Settings',
      icon: 'icon-settings',
      attributes: {
        'data-testid': 'nav-settings'
      },
      children: [
        {
          name: 'General Settings',
          url: '/settings/generalsettings',
          attributes: {
            'data-testid': 'nav-general-settings'
          }
        },
        {
          name: 'Notification Settings',
          url: '/settings/notificationsettings',
          attributes: {
            'data-testid': 'nav-notification-settings'
          }
        },
        {
          name: 'Branding',
          url: '/settings/brandingsettings',
          attributes: {
            'data-testid': 'nav-branding'
          }
        }
      ]
    },
    {
      name: 'Teamflect AI',
      customIcon: 'SparkleSvg',
      children: [
        {
          name: 'AI Agent',
          url: '/teamflect-ai/agent',
          attributes: {
            'data-testid': 'nav-teamflect-ai-agent'
          },
          data: {
            moduleKey: MODULES.AGENT
          }
        },
        {
          name: 'AI Settings',
          url: '/teamflect-ai/settings',
          attributes: {
            'data-testid': 'nav-teamflect-ai'
          },
          data: {
            moduleKey: MODULES.AI
          }
        }
      ]
    },
    {
      name: 'Modules',
      url: '/modules',
      icon: 'fa fa-diamond',
      attributes: {
        'data-testid': 'nav-modules'
      },
      children: [
        {
          name: 'Goals',
          url: '/goalsettings',
          attributes: {
            'data-testid': 'nav-goals'
          },
          data: {
            moduleKey: MODULES.GOALS
          }
        },
        {
          name: 'Meetings',
          url: '/meetingsettings',
          attributes: {
            'data-testid': 'nav-meetings'
          },
          data: {
            moduleKey: MODULES.MEETINGS
          }
        },
        {
          name: 'Tasks',
          url: '/tasksettings',
          attributes: {
            'data-testid': 'nav-tasks'
          },
          data: {
            moduleKey: MODULES.TASKS
          }
        },
        {
          name: 'Reviews',
          url: '/reviewsettings',
          attributes: {
            'data-testid': 'nav-reviews'
          },
          data: {
            moduleKey: MODULES.REVIEWS
          }
        },
        {
          name: 'Surveys',
          url: '/surveysettings',
          attributes: {
            'data-testid': 'nav-surveys'
          },
          data: {
            moduleKey: MODULES.SURVEYS
          }
        },
        {
          name: 'Feedback',
          url: '/feedbacksettings',
          attributes: {
            'data-testid': 'nav-feedback'
          },
          data: {
            moduleKey: MODULES.FEEDBACK
          }
        },
        {
          name: 'Recognitions',
          url: '/recognitionsettings',
          attributes: {
            'data-testid': 'nav-recognitions'
          },
          data: {
            moduleKey: MODULES.RECOGNITIONS
          }
        },
        {
          name: 'Notes',
          url: '/notesettings',
          attributes: {
            'data-testid': 'nav-notes'
          },
          data: {
            moduleKey: MODULES.NOTES
          }
        }
      ]
    },
    {
      name: 'Intranet',
      url: '/intranet',
      icon: 'fa-regular fa-building',
      isProPath: true,
      attributes: {
        'data-testid': 'nav-intranet'
      },
      data: {
        moduleKey: MODULES.MY_ORGANIZATION
      }
    },
    {
      name: 'Career',
      icon: 'icon-briefcase',
      attributes: {
        'data-testid': 'nav-career'
      },
      children: [
        {
          name: 'Roles (Job titles)',
          url: '/career/roles',
          attributes: {
            'data-testid': 'nav-roles'
          },
          data: {
            moduleKey: MODULES.ROLES
          }
        },
        {
          name: 'Competency Library',
          url: '/career/competencylibrary',
          attributes: {
            'data-testid': 'nav-competency-library'
          }
        },
        {
          name: 'Individual Development Plans',
          url: '/career/individual-development-plan',
          isProPath: true,
          attributes: {
            'data-testid': 'nav-individual-development-plan'
          },
          data: {
            moduleKey: MODULES.INDIVIDUAL_DEVELOPMENT_PLAN
          }
        },
        {
          name: 'Succession Plans',
          url: '/career/succession-plan',
          isProPath: true,
          attributes: {
            'data-testid': 'nav-succession-plan'
          },
          data: {
            moduleKey: MODULES.SUCCESSION_PLAN
          }
        },
        {
          name: 'Learning Materials',
          url: '/career/learningmaterials',
          isProPath: true,
          attributes: {
            'data-testid': 'nav-learning-materials'
          },
          data: {
            moduleKey: MODULES.LEARNING_MATERIALS
          }
        }
      ]
    },
    {
      name: 'Reports',
      url: '/reports',
      icon: 'icon-pie-chart',
      attributes: {
        'data-testid': 'nav-reports'
      }
    },
    {
      name: 'Security',
      url: '/security',
      icon: 'icon-lock',
      attributes: {
        'data-testid': 'nav-security'
      },
      children: [
        {
          name: 'Security Settings',
          url: '/security/securitysettings',
          attributes: {
            'data-testid': 'nav-security-settings'
          }
        },
        {
          name: 'Audit Logs',
          url: '/security/auditlogs',
          attributes: {
            'data-testid': 'nav-audit-logs'
          }
        },
        {
          name: 'Impersonation Logs',
          url: '/security/impersonationlogs',
          attributes: {
            'data-testid': 'nav-impersonation-logs'
          }
        }
      ]
    },

    {
      name: 'Licenses',
      url: '/licenses',
      icon: 'icon-info',
      attributes: {
        'data-testid': 'nav-licenses'
      }
    },
    {
      name: 'Referral program',
      url: '/referralprogram',
      icon: 'pi pi-gift',
      attributes: {
        'data-testid': 'nav-referral-program'
      }
    },
    {
      name: 'Support',
      url: '/support',
      icon: 'icon-support',
      attributes: {
        'data-testid': 'nav-support'
      }
    },
    {
      // Teamflect staff only — filtered out for every other tenant in DefaultLayout
      name: 'Experiments',
      url: '/experiments',
      icon: 'icon-chemistry',
      attributes: {
        'data-testid': 'nav-experiments'
      }
    },
    {
      name: 'Integrations & API',
      icon: 'icon-link',
      isProPath: true,
      attributes: {
        'data-testid': 'nav-integrations-api'
      },
      children: [
        {
          name: 'API keys',
          url: '/integrationsandapi/apikeys',
          attributes: {
            'data-testid': 'nav-api-keys'
          }
        },
        {
          name: 'Integrations',
          url: '/integrationsandapi/integrations',
          attributes: {
            'data-testid': 'nav-integrations'
          }
        }
      ]
    }
  ]
}
